var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _path, _rect3, _rect4, _path2, _path3, _path4, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path5, _g16, _g17, _g18, _rect5, _rect6, _rect7, _g19, _rect8, _rect9, _rect10, _g20, _rect11, _rect12, _rect13, _g21, _g22, _rect14, _path6, _path7, _g23, _g24, _rect15, _rect16, _rect17, _rect18, _rect19, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 626.933,
    height: 552.355,
    viewBox: "0 0 626.933 552.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1008.518 -4879.368)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1008.518 5343.693)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91.063,
    height: 55.806,
    rx: 4.218,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.432,386.5H55.384a1.3,1.3,0,0,1-1.3-1.3h0a1.3,1.3,0,0,1,1.3-1.3H75.432a1.3,1.3,0,0,1,1.3,1.3h0A1.3,1.3,0,0,1,75.432,386.5Z",
    transform: "translate(-47.331 -364.313)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.641,377.765H91.595a1.3,1.3,0,0,1-1.3-1.3h0a1.3,1.3,0,0,1,1.3-1.295h20.047a1.3,1.3,0,0,1,1.3,1.295h0A1.3,1.3,0,0,1,111.641,377.765Z",
    transform: "translate(-26.773 -369.273)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.432,403.925H55.384a1.3,1.3,0,0,1-1.3-1.3h0a1.3,1.3,0,0,1,1.3-1.3H75.432a1.3,1.3,0,0,1,1.3,1.3h0A1.3,1.3,0,0,1,75.432,403.925Z",
    transform: "translate(-47.331 -354.422)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.656,390.587H55.384a1.3,1.3,0,0,1-1.3-1.295h0a1.3,1.3,0,0,1,1.3-1.3h5.272a1.3,1.3,0,0,1,1.3,1.3h0A1.3,1.3,0,0,1,60.656,390.587Z",
    transform: "translate(-47.331 -361.994)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.992,
    height: 15.742,
    rx: 1.714,
    transform: "translate(63.849 36.158)",
    fill: "#e0e0e0",
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1058.075 4897.156)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 119.469,
    height: 73.214,
    rx: 4.218,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.043,106.381h-26.3a1.7,1.7,0,0,1-1.7-1.7h0a1.7,1.7,0,0,1,1.7-1.7h26.3a1.7,1.7,0,0,1,1.7,1.7h0A1.7,1.7,0,0,1,115.043,106.381Z",
    transform: "translate(-78.178 -77.269)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.551,94.919h-26.3a1.7,1.7,0,0,1-1.7-1.7h0a1.7,1.7,0,0,1,1.7-1.7h26.3a1.7,1.7,0,0,1,1.7,1.7h0A1.7,1.7,0,0,1,162.551,94.919Z",
    transform: "translate(-51.207 -83.777)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.703,
    height: 3.401,
    rx: 0.795,
    transform: "translate(8.864 61.543)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.66,111.741H88.741a1.7,1.7,0,0,1-1.7-1.7h0a1.7,1.7,0,0,1,1.7-1.7H95.66a1.7,1.7,0,0,1,1.7,1.7h0A1.7,1.7,0,0,1,95.66,111.741Z",
    transform: "translate(-78.178 -74.227)",
    fill: "#fafafa",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.853,
    height: 20.652,
    rx: 1.714,
    transform: "translate(83.766 47.437)",
    fill: "#e0e0e0",
    style: {
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1383.708 4879.368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.834,137.874v8.475h-6.2v-8.4c-7.412-.455-14.6-2.874-18.534-6.279l3.405-7.643a29.044,29.044,0,0,0,15.129,5.75V114.65c-8.4-2.043-17.4-4.766-17.4-15.282,0-7.716,5.6-14.45,17.4-15.585V75.234h6.2v8.4a32.416,32.416,0,0,1,15.359,4.614l-3.1,7.641A31.319,31.319,0,0,0,313.834,91.8v15.282c8.4,2.043,17.552,4.691,17.552,15.205C331.387,130.007,325.713,136.666,313.834,137.874Zm-6.2-32.378V92.029c-5.371.832-7.64,3.556-7.64,6.884C299.991,102.545,303.243,104.209,307.631,105.5ZM321.7,122.97c0-3.7-3.328-5.446-7.868-6.732v13.39C319.357,128.8,321.7,126.225,321.7,122.97Z",
    transform: "translate(-289.097 -75.234)",
    fill: "#e0e0e0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1585.932 5259.689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.947,365.577v6.461h-4.728v-6.4c-5.652-.346-11.131-2.192-14.13-4.786l2.6-5.827a22.147,22.147,0,0,0,11.534,4.385V347.873c-6.4-1.557-13.265-3.632-13.265-11.65,0-5.882,4.267-11.015,13.265-11.88v-6.516h4.728v6.4a24.734,24.734,0,0,1,11.708,3.518l-2.366,5.824a23.843,23.843,0,0,0-9.342-3.113V342.1c6.4,1.558,13.379,3.576,13.379,11.592C450.326,359.58,446,364.657,436.947,365.577Zm-4.728-24.682V330.629c-4.095.635-5.826,2.711-5.826,5.249C426.393,338.647,428.873,339.913,432.219,340.895Zm10.726,13.321c0-2.824-2.538-4.151-6-5.133v10.209C441.157,358.659,442.945,356.7,442.945,354.216Z",
    transform: "translate(-418.089 -317.827)",
    fill: "#e0e0e0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1011.457 5223.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.761,314.945q-3.109-3.111-3.109-8.55a12.953,12.953,0,0,1,1.436-6.282,9.77,9.77,0,0,1,3.974-4,12.572,12.572,0,0,1,11.421,0,9.787,9.787,0,0,1,3.977,4,12.952,12.952,0,0,1,1.433,6.282q0,5.439-3.107,8.55a10.849,10.849,0,0,1-8.014,3.109A10.844,10.844,0,0,1,54.761,314.945ZM87.348,295.33h10.1l-28.58,41.857h-10.1ZM64.656,310.37a10.917,10.917,0,0,0,0-7.95,2.059,2.059,0,0,0-3.767,0,10.96,10.96,0,0,0,0,7.95,2.06,2.06,0,0,0,3.767,0Zm20.779,24.3q-3.109-3.109-3.109-8.549a12.934,12.934,0,0,1,1.434-6.282,9.764,9.764,0,0,1,3.976-4,12.572,12.572,0,0,1,11.421,0,9.76,9.76,0,0,1,3.974,4,12.952,12.952,0,0,1,1.436,6.282q0,5.437-3.109,8.549a11.874,11.874,0,0,1-16.024,0Zm9.9-4.573a10.964,10.964,0,0,0,0-7.952,2.06,2.06,0,0,0-3.767,0,10.921,10.921,0,0,0,0,7.952,2.06,2.06,0,0,0,3.767,0Z",
    transform: "translate(-51.652 -294.737)",
    fill: "#e0e0e0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1522.565 4980.598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.082,168.485q-4.414-4.412-4.413-12.133a18.373,18.373,0,0,1,2.038-8.916,13.863,13.863,0,0,1,5.642-5.685,17.837,17.837,0,0,1,16.207,0,13.888,13.888,0,0,1,5.645,5.685,18.372,18.372,0,0,1,2.033,8.916q0,7.716-4.408,12.133a16.859,16.859,0,0,1-22.745,0Zm46.248-27.837h14.34l-40.562,59.4h-14.34Zm-32.206,21.346q1.063-1.743,1.065-5.642t-1.065-5.642a2.922,2.922,0,0,0-5.344,0q-1.061,1.74-1.06,5.642t1.06,5.642a2.922,2.922,0,0,0,5.344,0Zm29.492,34.495q-4.414-4.414-4.413-12.134a18.338,18.338,0,0,1,2.038-8.916,13.836,13.836,0,0,1,5.641-5.683,17.84,17.84,0,0,1,16.209,0,13.868,13.868,0,0,1,5.642,5.683,18.372,18.372,0,0,1,2.036,8.916q0,7.718-4.412,12.134a16.86,16.86,0,0,1-22.742,0ZM439.66,190q1.061-1.74,1.06-5.642t-1.06-5.642a2.923,2.923,0,0,0-5.346,0q-1.061,1.74-1.063,5.642T434.314,190a2.923,2.923,0,0,0,5.346,0Z",
    transform: "translate(-377.669 -139.805)",
    fill: "#e0e0e0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1018.448 5396.22)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.966,
    cy: 17.752,
    rx: 303.966,
    ry: 17.752,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1055.978 5034.106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.1,173.936H100.768A20.717,20.717,0,0,0,80.05,194.654V509.787A20.718,20.718,0,0,0,100.768,530.5h66.009v-10.1a5.378,5.378,0,0,1,5.377-5.379H526.716a5.379,5.379,0,0,1,5.379,5.379v10.1H598.1a20.719,20.719,0,0,0,20.719-20.718V194.654A20.718,20.718,0,0,0,598.1,173.936Z",
    transform: "translate(-80.05 -173.936)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.1,173.936H100.768A20.717,20.717,0,0,0,80.05,194.654V509.787A20.718,20.718,0,0,0,100.768,530.5h66.009v-10.1a5.378,5.378,0,0,1,5.377-5.379H526.716a5.379,5.379,0,0,1,5.379,5.379v10.1H598.1a20.719,20.719,0,0,0,20.719-20.718V194.654A20.718,20.718,0,0,0,598.1,173.936Z",
    transform: "translate(-80.05 -173.936)",
    fill: "#222f3e",
    opacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.821,184.168a4.361,4.361,0,1,1-4.361-4.36A4.362,4.362,0,0,1,257.821,184.168Z",
    transform: "translate(1071.903 4863.504)",
    fill: "#0533b3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 620.177,
    height: 15.523,
    transform: "translate(1015.275 5382.914)",
    fill: "#263238"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 620.177,
    height: 15.523,
    transform: "translate(1015.275 5382.914)",
    fill: "#e5e5e5",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.087,406.329l9.6,7.688A35.688,35.688,0,0,0,86,421.851H642.352a35.685,35.685,0,0,0,22.312-7.834l9.6-7.688Z",
    transform: "translate(961.188 4992.108)",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.087,406.329l9.6,7.688A35.688,35.688,0,0,0,86,421.851H642.352a35.685,35.685,0,0,0,22.312-7.834l9.6-7.688Z",
    transform: "translate(961.188 4992.108)",
    fill: "#222f3e",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.868,396.935a7.254,7.254,0,0,0,7.254,7.254H325.8a7.252,7.252,0,0,0,7.252-7.254c0-.174-.039-.337-.05-.508H213.92C213.907,396.6,213.868,396.761,213.868,396.935Z",
    transform: "translate(1051.901 4986.486)",
    fill: "#fff",
    opacity: 0.4
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1078.78 5065.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491.744,
    height: 279.875,
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144.171 5110.589)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 355.335,
    height: 11.758,
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 355.335,
    height: 11.758,
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1499.506 5110.589)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.732,
    height: 11.758,
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.732,
    height: 11.758,
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1078.78 5065.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491.744,
    height: 13.292,
    transform: "translate(0 0)",
    fill: "#0533b3"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1527.542 5068.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.469,199.789a3.813,3.813,0,1,1-3.813-3.813A3.813,3.813,0,0,1,388.469,199.789Z",
    transform: "translate(-380.844 -195.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.809,199.789A3.813,3.813,0,1,1,394,195.976,3.813,3.813,0,0,1,397.809,199.789Z",
    transform: "translate(-375.542 -195.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.147,199.789a3.813,3.813,0,1,1-3.813-3.813A3.813,3.813,0,0,1,407.147,199.789Z",
    transform: "translate(-370.24 -195.976)",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1087.861 5111.294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.3,233.242a6.436,6.436,0,0,1-1.916-.742l1.074-2.432a6.841,6.841,0,0,0,1.583.658,6.189,6.189,0,0,0,1.682.246,2.572,2.572,0,0,0,.989-.135.429.429,0,0,0,.3-.4c0-.208-.13-.364-.389-.467a8.6,8.6,0,0,0-1.279-.34,14.582,14.582,0,0,1-1.91-.514,3.259,3.259,0,0,1-1.328-.906,2.449,2.449,0,0,1-.566-1.7,2.929,2.929,0,0,1,.524-1.7,3.453,3.453,0,0,1,1.561-1.2,6.5,6.5,0,0,1,2.524-.437,9.191,9.191,0,0,1,2,.218,6.323,6.323,0,0,1,1.731.644l-1,2.417a6.126,6.126,0,0,0-2.758-.735q-1.286,0-1.286.621c0,.2.127.346.383.445a7.817,7.817,0,0,0,1.257.32,12.985,12.985,0,0,1,1.909.488,3.318,3.318,0,0,1,1.348.9,2.407,2.407,0,0,1,.574,1.7,2.9,2.9,0,0,1-.524,1.688,3.546,3.546,0,0,1-1.561,1.2,6.414,6.414,0,0,1-2.524.444A10.3,10.3,0,0,1,102.3,233.242Z",
    transform: "translate(-100.387 -223.171)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.038,225.9h-2.9v-2.587h9.132V225.9h-2.9v7.309h-3.336Z",
    transform: "translate(-97.121 -223.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.886,232.853a5.074,5.074,0,0,1,0-9.019,6.541,6.541,0,0,1,5.739,0,5.074,5.074,0,0,1,0,9.019,6.527,6.527,0,0,1-5.739,0Zm3.993-2.339a2.171,2.171,0,0,0,.8-.862,3.033,3.033,0,0,0,0-2.615,2.181,2.181,0,0,0-.8-.862,2.226,2.226,0,0,0-2.247,0,2.17,2.17,0,0,0-.8.862,3.033,3.033,0,0,0,0,2.615,2.16,2.16,0,0,0,.8.862,2.226,2.226,0,0,0,2.247,0Z",
    transform: "translate(-93.696 -223.171)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.312,230.723h-.9v2.488h-3.336v-9.9h4.763a5.853,5.853,0,0,1,2.389.453,3.655,3.655,0,0,1,1.64,5.131,3.4,3.4,0,0,1-1.384,1.257l2.077,3.054h-3.562Zm1.328-4.531a1.484,1.484,0,0,0-1.017-.3h-1.215v2.319h1.215a1.483,1.483,0,0,0,1.017-.3,1.245,1.245,0,0,0,0-1.71Z",
    transform: "translate(-89.212 -223.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.015,230.694v2.516h-8.227v-9.9h8.044v2.516h-4.764v1.159h4.184v2.4h-4.184v1.3Z",
    transform: "translate(-85.398 -223.089)",
    fill: "#263238"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1516.015 5106.652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.182,230.827a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,380.182,230.827Z",
    transform: "translate(-371.619 -215.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.937,230.827a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,386.937,230.827Z",
    transform: "translate(-367.784 -215.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.934,223.875l-1.149-3.665h-4.294v1.165h3.43l3.225,10.472h11.281l1-6.932Zm11.612,7.139-9.615-.105-1.817-6.109,12.213.9Z",
    transform: "translate(-373.491 -220.21)",
    fill: "#263238"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1078.78 5079.118)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491.744,
    height: 25.27,
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491.744,
    height: 25.27,
    fill: "#fff"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1110.772 5084.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.205,
    height: 13.847,
    rx: 3.379,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 296.205,
    height: 13.847,
    rx: 3.379,
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.14,207.321l1.725,3.495,3.856.56-2.79,2.72.659,3.841-3.449-1.813-3.449,1.813.659-3.841-2.79-2.72,3.856-.56Z",
    transform: "translate(-13.06 -205.705)",
    fill: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.849,206.083l-7.621,7.621h2.232v6.875h10.778V213.7h2.232Z",
    transform: "translate(987.951 4878.422)",
    fill: "#0533b3",
    opacity: 0.5
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1403.137 5145.294)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.129,
    height: 5.371,
    transform: "translate(0 0)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 71.681,
    height: 5.371,
    transform: "translate(0 8.64)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.003,
    height: 5.371,
    transform: "translate(0 17.281)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 83.124,
    height: 5.371,
    transform: "translate(0 25.921)",
    fill: "#0533b3"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1402.019 5188.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.232,
    height: 20.55,
    rx: 5.437,
    transform: "translate(0 0)",
    fill: "#13c4fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.787 7.838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.667,324.7a1.816,1.816,0,0,1,0,3.344,2.982,2.982,0,0,1-1.218.23h-.728v1.24h-1.7v-5.045h2.429A2.981,2.981,0,0,1,296.667,324.7Zm-.807,2.108a.635.635,0,0,0,0-.872.755.755,0,0,0-.518-.156h-.62v1.182h.62A.755.755,0,0,0,295.859,326.807Z",
    transform: "translate(-293.02 -324.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.927,325.833a1.77,1.77,0,0,1,.548,1.43v2.119h-1.514v-.52a1.112,1.112,0,0,1-1.117.592,1.782,1.782,0,0,1-.8-.163,1.141,1.141,0,0,1-.667-1.063,1,1,0,0,1,.447-.886,2.439,2.439,0,0,1,1.354-.3h.656c-.053-.307-.3-.461-.742-.461a1.826,1.826,0,0,0-.54.084,1.539,1.539,0,0,0-.469.226l-.518-1.073a2.872,2.872,0,0,1,.818-.328,3.962,3.962,0,0,1,.955-.119A2.386,2.386,0,0,1,300.927,325.833Zm-1.282,2.547a.545.545,0,0,0,.2-.281v-.273h-.4q-.5,0-.5.33a.285.285,0,0,0,.1.227.419.419,0,0,0,.284.091A.534.534,0,0,0,299.645,328.38Z",
    transform: "translate(-292.38 -324.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.953,325.43l-1.622,4.022a2.286,2.286,0,0,1-.771,1.081,1.984,1.984,0,0,1-1.132.31,2.41,2.41,0,0,1-.666-.1,1.5,1.5,0,0,1-.53-.256l.54-1.117a1.085,1.085,0,0,0,.279.151.859.859,0,0,0,.3.057.506.506,0,0,0,.4-.158L301.1,325.43h1.672l.814,2.112.828-2.112Z",
    transform: "translate(-291.835 -324.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.911,325.807a1.83,1.83,0,0,1,.429,1.326v2.249h-1.628v-1.968c0-.452-.147-.677-.44-.677a.455.455,0,0,0-.37.172.865.865,0,0,0-.141.548v1.924h-1.628v-1.968c0-.452-.147-.677-.439-.677a.455.455,0,0,0-.372.172.865.865,0,0,0-.141.548v1.924h-1.628v-3.943h1.55v.368a1.51,1.51,0,0,1,1.116-.44,1.673,1.673,0,0,1,.714.148,1.25,1.25,0,0,1,.518.451,1.6,1.6,0,0,1,.577-.443,1.744,1.744,0,0,1,.742-.156A1.52,1.52,0,0,1,311.911,325.807Z",
    transform: "translate(-291.181 -324.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.349,327.789H313.61a.673.673,0,0,0,.288.343,1,1,0,0,0,.506.118,1.3,1.3,0,0,0,.436-.064,1.552,1.552,0,0,0,.385-.224l.85.858a2.212,2.212,0,0,1-1.721.634,2.833,2.833,0,0,1-1.255-.264,1.982,1.982,0,0,1-.836-.732,2.035,2.035,0,0,1,0-2.108,2,2,0,0,1,.8-.724,2.629,2.629,0,0,1,2.235-.022,1.874,1.874,0,0,1,.786.7,2.027,2.027,0,0,1,.291,1.1C316.371,327.431,316.364,327.559,316.349,327.789Zm-2.55-1.174a.647.647,0,0,0-.217.389h1.268a.663.663,0,0,0-.216-.385.7.7,0,0,0-.836,0Z",
    transform: "translate(-290.239 -324.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.164,325.807a1.8,1.8,0,0,1,.443,1.326v2.249h-1.628v-1.968c0-.452-.162-.677-.483-.677a.565.565,0,0,0-.444.19.9.9,0,0,0-.169.6v1.852h-1.63v-3.943H317.8v.39a1.525,1.525,0,0,1,.533-.346,1.831,1.831,0,0,1,.656-.116A1.592,1.592,0,0,1,320.164,325.807Z",
    transform: "translate(-289.61 -324.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.616,329.349a2.027,2.027,0,0,1-1,.21,1.849,1.849,0,0,1-1.275-.4,1.528,1.528,0,0,1-.447-1.2v-1.008h-.54V325.76h.54v-1.1h1.628v1.1h.807v1.189h-.807v.994a.393.393,0,0,0,.094.281.317.317,0,0,0,.245.1.634.634,0,0,0,.367-.108Z",
    transform: "translate(-289.008 -324.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.99,329.514l-.015-2.3-1.1,1.845h-.75l-1.1-1.766v2.22h-1.549v-5.045h1.4l1.643,2.688,1.6-2.688h1.4l.014,5.045Z",
    transform: "translate(-288.255 -324.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.636,327.789H332.9a.668.668,0,0,0,.288.343.993.993,0,0,0,.5.118,1.29,1.29,0,0,0,.436-.064,1.531,1.531,0,0,0,.385-.224l.851.858a2.215,2.215,0,0,1-1.722.634,2.827,2.827,0,0,1-1.253-.264,1.968,1.968,0,0,1-.836-.732,1.927,1.927,0,0,1-.3-1.052,1.952,1.952,0,0,1,.291-1.056,2,2,0,0,1,.8-.724,2.627,2.627,0,0,1,2.234-.022,1.874,1.874,0,0,1,.786.7,2.017,2.017,0,0,1,.292,1.1C335.658,327.431,335.65,327.559,335.636,327.789Zm-2.552-1.174a.646.646,0,0,0-.216.389h1.268a.665.665,0,0,0-.217-.385.622.622,0,0,0-.417-.141A.633.633,0,0,0,333.084,326.615Z",
    transform: "translate(-287.408 -324.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.49,329.349a2.019,2.019,0,0,1-1,.21,1.849,1.849,0,0,1-1.275-.4,1.528,1.528,0,0,1-.447-1.2v-1.008h-.54V325.76h.54v-1.1h1.628v1.1h.807v1.189h-.807v.994a.4.4,0,0,0,.094.281.315.315,0,0,0,.244.1.635.635,0,0,0,.368-.108Z",
    transform: "translate(-286.825 -324.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.34,325.978a1.791,1.791,0,0,1,.444,1.326v2.249h-1.63v-1.968c0-.452-.161-.677-.483-.677a.562.562,0,0,0-.443.19.888.888,0,0,0-.17.6v1.852h-1.628v-5.348h1.628v1.723a1.65,1.65,0,0,1,1.11-.39A1.589,1.589,0,0,1,342.34,325.978Z",
    transform: "translate(-286.354 -324.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.837,329.19a2.018,2.018,0,0,1-.819-.727,2.039,2.039,0,0,1,0-2.112,2,2,0,0,1,.819-.724,2.813,2.813,0,0,1,2.364,0,1.968,1.968,0,0,1,.814.724,2.053,2.053,0,0,1,0,2.112,1.983,1.983,0,0,1-.814.727,2.779,2.779,0,0,1-2.364,0Zm1.639-1.211a.99.99,0,0,0,0-1.142.63.63,0,0,0-.922,0,1,1,0,0,0,0,1.142.618.618,0,0,0,.922,0Z",
    transform: "translate(-285.724 -324.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.548,324.205v5.348H350v-.325a1.379,1.379,0,0,1-1.081.4,1.9,1.9,0,0,1-.954-.249,1.8,1.8,0,0,1-.693-.717,2.407,2.407,0,0,1,0-2.159,1.8,1.8,0,0,1,.693-.713,1.9,1.9,0,0,1,.954-.249,1.375,1.375,0,0,1,1,.339v-1.672Zm-1.78,3.945a1,1,0,0,0,0-1.142.631.631,0,0,0-.923,0,1,1,0,0,0,0,1.142.619.619,0,0,0,.923,0Z",
    transform: "translate(-285.094 -324.205)",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1210.57 5145.573)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.382,
    height: 7.874,
    transform: "translate(0 0)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.879,
    height: 7.873,
    transform: "translate(0 10.955)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.545,
    height: 7.874,
    transform: "translate(0 21.909)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.947,
    height: 7.874,
    transform: "translate(0.493 32.864)",
    fill: "#0533b3"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 40.738,
    height: 40.738,
    rx: 3.887,
    transform: "translate(1161.651 5145.574)",
    fill: "#0533b3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 17.623,
    height: 17.623,
    rx: 1.013,
    transform: "translate(1173.208 5157.131)",
    fill: "#fff",
    opacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8.672,
    height: 8.672,
    rx: 0.87,
    transform: "translate(1180.005 5158.812)",
    fill: "#fff"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1210.57 5207.241)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.382,
    height: 7.874,
    transform: "translate(0 0)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.879,
    height: 7.873,
    transform: "translate(0 10.955)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.545,
    height: 7.874,
    transform: "translate(0 21.91)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.947,
    height: 7.874,
    transform: "translate(0.493 32.864)",
    fill: "#0533b3"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 40.738,
    height: 40.738,
    rx: 3.887,
    transform: "translate(1161.651 5207.24)",
    fill: "#0533b3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 17.623,
    height: 17.623,
    rx: 1.013,
    transform: "translate(1173.208 5218.798)",
    fill: "#fff",
    opacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.672,
    height: 8.672,
    rx: 0.87,
    transform: "translate(1180.005 5220.478)",
    fill: "#fff"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1210.57 5268.907)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.382,
    height: 7.874,
    transform: "translate(0 0)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.879,
    height: 7.873,
    transform: "translate(0 10.955)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.545,
    height: 7.874,
    transform: "translate(0 21.91)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.947,
    height: 7.874,
    transform: "translate(0.493 32.864)",
    fill: "#0533b3"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 40.738,
    height: 40.738,
    rx: 3.887,
    transform: "translate(1161.651 5268.907)",
    fill: "#0533b3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 17.623,
    height: 17.623,
    rx: 1.013,
    transform: "translate(1173.208 5280.465)",
    fill: "#fff",
    opacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8.672,
    height: 8.672,
    rx: 0.87,
    transform: "translate(1180.005 5282.145)",
    fill: "#fff"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1180.964 4899.845)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.5,
    height: 249.661,
    transform: "translate(0 0)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1169.219 4886.603)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.5,
    height: 249.661,
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 167.532,
    height: 26.112,
    transform: "translate(1169.196 4886.602)",
    fill: "#0533b3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262.131,88.355a6.395,6.395,0,1,1-6.395-6.394A6.395,6.395,0,0,1,262.131,88.355Z",
    transform: "translate(1066.389 4811.042)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.19,240.741H177.08c-8.978,0-16.255-8.066-16.255-18.016h0c0-9.95,7.278-18.016,16.255-18.016h96.11c8.978,0,16.255,8.066,16.255,18.016h0C289.445,232.675,282.168,240.741,273.19,240.741Z",
    transform: "translate(1028.754 4877.641)",
    fill: "#13c4fc"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1219.289 5095.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.817,219.268a4.045,4.045,0,0,1-1.625-1.514,4.435,4.435,0,0,1,0-4.417,4.047,4.047,0,0,1,1.625-1.515,4.959,4.959,0,0,1,2.33-.541,5.12,5.12,0,0,1,2.12.419,3.937,3.937,0,0,1,1.538,1.212l-1.736,1.55a2.228,2.228,0,0,0-1.783-.955,1.821,1.821,0,0,0-1.386.553,2.366,2.366,0,0,0,0,2.971,1.821,1.821,0,0,0,1.386.553,2.226,2.226,0,0,0,1.783-.955l1.736,1.55a3.93,3.93,0,0,1-1.538,1.212,5.12,5.12,0,0,1-2.12.419A4.949,4.949,0,0,1,169.817,219.268Z",
    transform: "translate(-167.603 -211.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.694,211.489v8.157h-2.749v-3.006H180.4v3.006h-2.75v-8.157h2.75v2.89h2.541v-2.89Z",
    transform: "translate(-168.659 -211.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,217.571v2.075h-6.781v-8.157h6.631v2.074h-3.928v.956h3.449V216.5h-3.449v1.072Z",
    transform: "translate(-169.759 -211.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.734,219.268a4.051,4.051,0,0,1-1.625-1.514,4.441,4.441,0,0,1,0-4.417,4.053,4.053,0,0,1,1.625-1.515,4.964,4.964,0,0,1,2.33-.541,5.121,5.121,0,0,1,2.121.419,3.943,3.943,0,0,1,1.538,1.212l-1.736,1.55a2.229,2.229,0,0,0-1.783-.955,1.821,1.821,0,0,0-1.386.553,2.366,2.366,0,0,0,0,2.971,1.821,1.821,0,0,0,1.386.553,2.227,2.227,0,0,0,1.783-.955l1.736,1.55a3.936,3.936,0,0,1-1.538,1.212,5.121,5.121,0,0,1-2.121.419A4.954,4.954,0,0,1,198.734,219.268Z",
    transform: "translate(-170.641 -211.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.893,216.942l-.618.688v2.015h-2.7v-8.157h2.7v2.96l2.68-2.96h2.994l-3.263,3.589,3.426,4.568h-3.181Z",
    transform: "translate(-171.697 -211.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,219.262a4.181,4.181,0,0,1,0-7.433,5.381,5.381,0,0,1,4.731,0,4.18,4.18,0,0,1,0,7.433,5.381,5.381,0,0,1-4.731,0Zm3.292-1.928a1.807,1.807,0,0,0,.659-.711,2.492,2.492,0,0,0,0-2.156,1.8,1.8,0,0,0-.659-.711,1.843,1.843,0,0,0-1.853,0,1.8,1.8,0,0,0-.659.711,2.5,2.5,0,0,0,0,2.156,1.807,1.807,0,0,0,.659.711,1.843,1.843,0,0,0,1.853,0Z",
    transform: "translate(-172.671 -211.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.219,218.819a3.77,3.77,0,0,1-1.049-2.843v-4.486h2.75v4.4a2.118,2.118,0,0,0,.32,1.3,1.258,1.258,0,0,0,1.853,0,2.124,2.124,0,0,0,.32-1.3v-4.4h2.7v4.486a3.77,3.77,0,0,1-1.048,2.843,4.73,4.73,0,0,1-5.85,0Z",
    transform: "translate(-173.861 -211.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.025,213.622h-2.389v-2.133h7.527v2.133h-2.389v6.024h-2.75Z",
    transform: "translate(-174.855 -211.303)",
    fill: "#fff"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1189.558 4945.751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.583,124.053h-6.327V118.4H190.2v5.649h-6.329V140.01h-7.284Z",
    transform: "translate(-170.256 -117.107)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.153,137.6a8.659,8.659,0,0,1-3.5-3.118,8.705,8.705,0,0,1,0-9.044,8.546,8.546,0,0,1,3.5-3.1,12.083,12.083,0,0,1,10.124,0,8.448,8.448,0,0,1,3.488,3.1,8.808,8.808,0,0,1,0,9.044,8.559,8.559,0,0,1-3.488,3.118,11.946,11.946,0,0,1-10.124,0Zm7.022-5.186a3.6,3.6,0,0,0,.773-2.455,3.54,3.54,0,0,0-.773-2.438,2.69,2.69,0,0,0-3.951,0,3.54,3.54,0,0,0-.771,2.438,3.6,3.6,0,0,0,.771,2.455,2.661,2.661,0,0,0,3.951,0Z",
    transform: "translate(-163.371 -115.509)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,139.089a8.7,8.7,0,0,1-4.291.9,7.928,7.928,0,0,1-5.464-1.712,6.547,6.547,0,0,1-1.914-5.141V128.81H195.32v-5.092h2.314v-4.724h6.976v4.724h3.457v5.092H204.61v4.261a1.7,1.7,0,0,0,.4,1.2,1.36,1.36,0,0,0,1.049.433,2.74,2.74,0,0,0,1.576-.463Z",
    transform: "translate(-156.026 -116.773)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.018,123.21q2.345,1.992,2.344,6.128v9.074h-6.481v-2.221q-1.2,2.53-4.785,2.53a7.638,7.638,0,0,1-3.41-.694,4.892,4.892,0,0,1-2.856-4.553,4.3,4.3,0,0,1,1.914-3.8,10.451,10.451,0,0,1,5.8-1.3h2.809q-.341-1.975-3.181-1.975a7.928,7.928,0,0,0-2.316.356,6.455,6.455,0,0,0-2.005.972l-2.223-4.6a12.324,12.324,0,0,1,3.5-1.4,16.9,16.9,0,0,1,4.09-.51Q217.671,121.219,220.018,123.21Zm-5.495,10.911a2.314,2.314,0,0,0,.864-1.2v-1.171h-1.729q-2.131,0-2.129,1.419a1.222,1.222,0,0,0,.448.972,1.8,1.8,0,0,0,1.218.386A2.292,2.292,0,0,0,214.523,134.121Z",
    transform: "translate(-150.627 -115.509)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.943,117.577h6.976v22.9h-6.976Z",
    transform: "translate(-143.183 -117.577)",
    fill: "#0533b3"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 49.063,
    height: 5.401,
    transform: "translate(1189.579 5000.712)",
    fill: "#0533b3",
    opacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 35.633,
    height: 5.4,
    transform: "translate(1189.579 4987.453)",
    fill: "#263238",
    opacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 58.299,
    height: 5.4,
    transform: "translate(1189.579 5015.114)",
    fill: "#0533b3",
    opacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 26.993,
    height: 5.4,
    transform: "translate(1286.628 5015.114)",
    fill: "#0533b3",
    opacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 41.393,
    height: 5.4,
    transform: "translate(1189.579 5036.872)",
    fill: "#0533b3",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9,11.792A4.9,4.9,0,1,0,2,6.9,4.9,4.9,0,0,0,6.9,11.792ZM8.627,5.165a.49.49,0,0,1,.692.693L6.552,8.626l0,0a.488.488,0,0,1-.692,0l0,0L4.472,7.242a.49.49,0,1,1,.692-.692L6.2,7.589,8.627,5.165Z",
    transform: "translate(1142.911 5144.018)",
    fill: "#0533b3",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9,11.792A4.9,4.9,0,1,0,2,6.9,4.9,4.9,0,0,0,6.9,11.792ZM8.627,5.165a.49.49,0,0,1,.692.693L6.552,8.626l0,0a.488.488,0,0,1-.692,0l0,0L4.472,7.242a.49.49,0,1,1,.692-.692L6.2,7.589,8.627,5.165Z",
    transform: "translate(1142.911 5205.611)",
    fill: "#0533b3",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9,11.792A4.9,4.9,0,1,0,2,6.9,4.9,4.9,0,0,0,6.9,11.792ZM8.627,5.165a.49.49,0,0,1,.692.693L6.552,8.626l0,0a.488.488,0,0,1-.692,0l0,0L4.472,7.242a.49.49,0,1,1,.692-.692L6.2,7.589,8.627,5.165Z",
    transform: "translate(1142.911 5267.205)",
    fill: "#0533b3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.d447b70c0325787a3b5cc37cba3230ee.svg";
export { ForwardRef as ReactComponent };